export default "__VITE_ASSET__kYKbOTMT__"